import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {
  ConductivityprofileImport,
  ListConductivityprofiles,
} from 'src/app/models/conductivityprofiles.model';
import { Plant } from 'src/app/models/plant.model';
import { Router } from '@angular/router';
import { Train } from 'src/app/models/train.model';
import { ConductivityprofilesService } from 'src/app/services/conductivityprofiles/conductivityprofiles.service';
import { PlantsService } from 'src/app/services/plants/plants.service';
import { TrainService } from 'src/app/services/trains/trains.service';

@Component({
  selector: 'app-import-conductivityprofiles',
  templateUrl: './import-conductivityprofiles.component.html',
  styleUrls: ['./import-conductivityprofiles.component.scss'],
})
export class ImportConductivityprofilesComponent {
  constructor(
    private router: Router,
    private trainService: TrainService,
    private toastr: ToastrService,
    private plantService: PlantsService,
    private conductivityprofilesservice: ConductivityprofilesService
  ) {}

  dtoptions: DataTables.Settings = {};
  plants: Plant[] = [];
  trains: Train[] = [];
  trainId: string;
  WorkSheet: string;
  colforstage: string;
  headerrow: string;
  fileSelected: File;
  showAlert = false;
  AlerterOn=false;
  showImportDiv = true;
  syncOption: string = 'Alert';
  fileName = '';
  ListConductivityprofiles: ListConductivityprofiles[] = [];
  SelectedId: string;
  plantDetails: Plant = new Plant();
  conductivityprofileImport: ConductivityprofileImport =
    new ConductivityprofileImport();
  trainDetails: Train = new Train();
  errorsList: string[] = [];

  loggedInUserRole:string;
  loggedinUserId:string;
  plantAndUserId:string;

  onFileSelected(event) {
    this.fileSelected = event.target.files[0];

    if (this.fileSelected) {
      this.fileName = this.fileSelected.name;
    }
  }

  getSelectedId(e) {
   
    this.SelectedId = e.target.value;

    if(this.loggedInUserRole =='Standard User')
      {
    this.plantAndUserId = this.SelectedId + 'Z' + this.loggedinUserId;
    this.trainService.GetAccessibleTrainListByPlantId(this.plantAndUserId)
      
      .subscribe(
        (response: Train[]) => {
          this.trains = response;
        },
        (error: any) => {
          console.log('error list');
        }
      );
  }
  else
  {
    
    this.trainService.getTrainByPlantId(this.SelectedId).subscribe(
      (response: Train[]) => {
        this.trains = response;
      },

      (error: any) => {
        console.log('error list');
      }
    );
  }
  }
  setSyncOption(e: string) {
    this.syncOption = e;
    console.log(this.syncOption);
  }

  getSelectedTrainId(e) {
    this.trainId = e.target.value;

   
  }

  getWorkSheet(e) {
    this.WorkSheet = e.target.value;
  }

  getcolforstage(e) {
    this.colforstage = e.target.value;
  }

  getheaderrow(e) {
    this.headerrow = e.target.value;
  }

  refesher()
  {
    this.AlerterOn = false;
    this.showAlert = false;
  }

  loader()
  {
    window.location.reload();
  }

  importConductivityprofile() {
    this.conductivityprofileImport.TrainId = this.trainId;
    
    this.conductivityprofileImport.ImportOption = this.syncOption;
  
    console.log(this.fileSelected.name);
    console.log(this.conductivityprofileImport);
   
    this.conductivityprofilesservice
      .importConductivityprofile(
        this.conductivityprofileImport,
        this.fileSelected
      )
      .subscribe({
        next: (model) => {
          console.log(model);
          
          if (
            model.ImportOption == 'DeleteAllExisting' ||
            model.ImportOption == 'ReplaceExisting'
          ) {

            this.showAlert = false;
            this.showImportDiv = true;
            this.toastr.success(
              'Conductivity Profile Imported Successfully.',
              'Information'
            );
            this.router.navigate(['/component/conductivityprofile']);
          } else if (model.ImportOption == 'Alert') {
            if (model.duplicateEleList == '') {
              this.showAlert = false;
              this.showImportDiv = true;
              this.toastr.success(
                'Conductivity Profile Imported Successfully.',
                'Information'
              );
              this.router.navigate(['/component/conductivityprofile']);
            } else {
              this.AlerterOn = true;
              this.showAlert = true;
              this.showImportDiv = false;
              var splitErrs = model.duplicateEleList.split(';');
              splitErrs.forEach((element) => {
                if (element != '') {
                  this.errorsList.push(element);
                }
              });
            }
          }
        },
      });
  }

  ngOnInit(): void {
    this.dtoptions = {
      pagingType: 'full_numbers',
      order: [[0, 'desc']],
    };
    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if(loggedInuserRole.role =='Standard User')
    {
      this.loggedInUserRole = loggedInuserRole.role;
      this.loggedinUserId = loggedInuserRole.userId;
      this.plantService.getPlantsByUserId(loggedInuserRole.userId)
      .subscribe({
        next: (plants)=>{
          this.plants = plants;
        },
      })
      
    }
    else
    {
    this.plantService.getAllPlant().subscribe({
      next: (plants) => {
        this.plants = plants;
      },
      error: (response) => {
        console.log(response);
      },
    });
  }

     // get plantId from breadcrumbs
    this.plantService.selectedPlant$
      .subscribe(plantId => {
        if (plantId) {
          this.getSelectedId({ target: { value: plantId } });
        }
      });

    // get trainid from breadcrumbs
    this.plantService.selectedTrain$
      .subscribe(trainId => {
        if (trainId) {
          this.getSelectedTrainId({ target: { value: trainId } });
        }
      });
}
}
